module.exports = __webpack_public_path__ + "img/banner-05e.866d8bb2.png";